import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img_avatar.png'


const _withScopeId = n => (_pushScopeId("data-v-5c4fbd95"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sidebar-profile d-flex pt-4 ps-3"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-avatar me-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "avatar"
  })
], -1))
const _hoisted_3 = { class: "profile-case d-flex align-items-center" }
const _hoisted_4 = { class: "profile-info d-flex flex-column me-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fst-normal" }, "Пользователь", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-sign-out" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"sidebar-profile-preloader d-flex pt-4 ps-3\" data-v-5c4fbd95><div class=\"profile-avatar me-3\" data-v-5c4fbd95><div class=\"rounded-circle avatar\" data-v-5c4fbd95></div></div><div class=\"profile-case d-flex align-items-center\" data-v-5c4fbd95><div class=\"profile-info d-flex flex-column me-3\" data-v-5c4fbd95><div class=\"username rounded\" data-v-5c4fbd95></div><div class=\"user-role rounded\" data-v-5c4fbd95></div></div><span data-v-5c4fbd95><a data-v-5c4fbd95><i class=\"far fa-sign-out\" data-v-5c4fbd95></i></a></span></div></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.getLoggedStatus && !_ctx.getUserPreloader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("b", null, _toDisplayString(_ctx.getUsername), 1),
              _hoisted_5
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.logout()), ["prevent"]))
              }, _hoisted_7)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, _hoisted_9, 512), [
      [_vShow, _ctx.getUserPreloader]
    ])
  ], 64))
}